import { render, staticRenderFns } from "./VistaGmail.vue?vue&type=template&id=7858c94c"
import script from "./VistaGmail.vue?vue&type=script&lang=js"
export * from "./VistaGmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports